import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setLanguage } from '../../store/slices/languageSlice';
import { toggleTheme } from '../../store/slices/themeSlice';
import { RootState } from '../../store/store';
import userIcon from '../../assets/icons/Icon-Header-My_profile.svg';
import logoutIcon from '../../assets/icons/Icon-Header-My_profile-Log_out.svg';
import enLanguageIcon from '../../assets/icons/flags/EN.svg';
import deLanguageIcon from '../../assets/icons/flags/DE.svg';
import sunIcon from '../../assets/icons/Icon-Header-Sun.svg';
import moonIcon from '../../assets/icons/Icon-Header-moon.svg';
import NotificationBell from '../notifications/NotificationBell';

interface HeaderToolbarProps {
  isLoginHeader: boolean;
  onLogout?: () => void;
  onProfileClick?: () => void;
}

const HeaderToolbar: React.FC<HeaderToolbarProps> = ({
  isLoginHeader,
  onLogout,
  onProfileClick,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const selectedLanguage = useSelector((state: RootState) => state.language.selectedLanguage);
  const selectedTheme = useSelector((state: RootState) => state.theme.selectedTheme);
  const profile = useSelector((state: RootState) => state.profile);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen((open) => !open);
  };

  const handleLanguageChange = (lang: string) => {
    dispatch(setLanguage(lang));
    setIsDropdownOpen(false);
  };

  const handleThemeToggle = () => {
    dispatch(toggleTheme(selectedTheme === 'light' ? 'dark' : 'light'));
  };

  return (
    <>
      <div className={`language-selector ${isDropdownOpen ? 'active' : ''}`}>
        <button className="language-button" onClick={toggleDropdown} aria-label={t('language')}>
          <img
            src={selectedLanguage === 'en' ? enLanguageIcon : deLanguageIcon}
            alt={t('language')}
            className="language-icon"
          />
          <span className="language-button__code">
            {selectedLanguage === 'en' ? 'EN' : 'DE'}
          </span>
          <span className="arrow language-button__chevron" aria-hidden="true">
            ❯
          </span>
        </button>
        <ul className="language-dropdown">
          <li onClick={() => handleLanguageChange('en')}>
            <img src={enLanguageIcon} alt={t('countryCode_en')} className="language-icon" /> {t('countryCode_en')}
          </li>
          <li onClick={() => handleLanguageChange('de')}>
            <img src={deLanguageIcon} alt={t('countryCode_de')} className="language-icon" /> {t('countryCode_de')}
          </li>
        </ul>
      </div>
      {!isLoginHeader && <NotificationBell />}
      <div className="theme-button header-theme-desktop">
        <button className="theme-toggle" onClick={handleThemeToggle} aria-label={t('theme')}>
          <img src={selectedTheme === 'dark' ? sunIcon : moonIcon} alt={t('theme')} className="theme-icon" />
        </button>
      </div>
      {!isLoginHeader && (
        <div className="user-menu">
          {profile && !profile.contact?.parentUserId && (
            <Link to="/profile" className="profile-link" onClick={onProfileClick}>
              <img src={userIcon} alt={t('profile')} className="user-icon" />
              {t('profile_menu')}
            </Link>
          )}
          <button type="button" className="logout-button" onClick={onLogout} aria-label={t('logOut')}>
            <img src={logoutIcon} alt={t('logOut')} className="logout-icon" />
          </button>
        </div>
      )}
    </>
  );
};

export default HeaderToolbar;
